import { render, staticRenderFns } from "./Category.vue?vue&type=template&id=f53d6770&scoped=true"
import script from "./Category.vue?vue&type=script&lang=js"
export * from "./Category.vue?vue&type=script&lang=js"
import style0 from "./Category.vue?vue&type=style&index=0&id=f53d6770&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f53d6770",
  null
  
)

export default component.exports